import getDevice from './module/getDevice.js'
import functions from './functions.js' 

const deviceData = getDevice()
window.deviceData = deviceData

/* Ejecutar el getDevice si cambia el tamaño del navegador o rota el dispositivo */
window.addEventListener('resize', getDevice)
window.addEventListener('orientationchange', getDevice)

document.addEventListener('DOMContentLoaded', function () {
  functions(deviceData)
})
